module.exports = __webpack_public_path__ + "img/192.d1a712e3.jpg";